import { useRef, useState } from "react";
import { Headline, SubHeadline } from "../components";
import { useRecentlyUsed, useCustomers } from "../hooks";
import { motion } from "framer-motion";
import dayjs from "dayjs";
import Skeleton from "react-loading-skeleton";
import snippets from "../i18n/lang";
import { Link } from "react-router";
import truncateText from "../utils/truncate";
import { classNames } from "../utils";
import { getFallbackRange } from "../utils/getFallbackRange";

export const RecentlyUsed = () => {
  const { data: customers, isLoading } = useCustomers();
  const { recentlyUsed, onCustomerSelect } = useRecentlyUsed();
  const dragConstraint = useRef<HTMLDivElement>(null);
  const [isDragging, setIsDragging] = useState(false);

  if (!recentlyUsed.length) return null;
  return (
    <div className="mb-6">
      <Headline>{snippets.customerOverview.fequentlyUsed}</Headline>
      <div ref={dragConstraint} className=" flex  overflow-hidden">
        <motion.div
          drag="x"
          dragConstraints={dragConstraint}
          dragSnapToOrigin={false}
          className="flex gap-3 flex-row mt-3"
          onDragStart={(e) => setIsDragging(true)}
          onDragEnd={(e) => setIsDragging(false)}
        >
          {isLoading
            ? Array(5)
                .fill(0)
                .map((_, i) => (
                  <div
                    key={i}
                    draggable={false}
                    className={classNames(
                      "border select-none rounded-lg p-4 flex-col flex gap-3 items-center justify-center w-full flex-grow min-w-[150px] hover:bg-gray-50 cursor-pointer"
                    )}
                  >
                    <Skeleton
                      circle
                      className="aspect-square  items-center justify-center rounded-full h-16 w-16 overflow-hidden"
                    />
                    <SubHeadline className="whitespace-nowrap break-keep w-full ">
                      <Skeleton />
                    </SubHeadline>
                  </div>
                ))
            : recentlyUsed
                .slice(0, 5)
                .map((id) =>
                  customers?.find((customer) => customer.shortID === id)
                )
                .filter(Boolean)
                ?.map((c) => {
                  const {
                    title,
                    shortID,
                    dataManagerID,
                    favicon,
                    seoTitle,
                    hexColor,
                  } = c;
                  return (
                    <Link
                      to={`/${dataManagerID}?start=${
                        getFallbackRange().start
                      }&end=${getFallbackRange().end}`}
                      onClick={() => !isDragging && onCustomerSelect(c)}
                      draggable={false}
                      key={shortID}
                      className={classNames(
                        "border select-none rounded-lg p-4 flex-col flex gap-3 items-center justify-center w-full flex-grow min-w-[150px] hover:bg-gray-50 cursor-pointer",
                        isDragging
                          ? "pointer-events-none"
                          : "pointer-events-auto"
                      )}
                    >
                      <div className="aspect-square flex items-center justify-center rounded-full h-16 w-16 overflow-hidden">
                        {favicon ? (
                          <img
                            src={favicon}
                            draggable="false"
                            className="h-full w-full"
                          />
                        ) : (
                          <div
                            className="h-full w-full bg-gray-50 flex items-center justify-center"
                            style={{ color: hexColor }}
                          >
                            {title.substr(0, 2).toUpperCase()}
                          </div>
                        )}
                      </div>
                      <div className="flex items-center gap-2">
                        <span
                          className="w-3 h-3 aspect-square rounded-full inline-flex"
                          style={{ backgroundColor: hexColor }}
                        />
                        <SubHeadline className="whitespace-nowrap break-keep ">
                          <span>{truncateText(title, 10)}</span>
                        </SubHeadline>
                      </div>
                    </Link>
                  );
                })}
        </motion.div>
      </div>
    </div>
  );
};
